import { useState } from 'react';
import { toast } from 'react-toastify';
import fleetApi from '../../services/api.service';

export default function useArchivePackaging() {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);

  const archivePackaging = async (id) => {
    setIsSuccess(null);
    try {
      setIsLoading(true);
      const response = await fleetApi.post(`/packaging/${id}/archive`);
      setIsSuccess(true);
      toast.success(response.data?.message || 'Type de palette archivé.');
    } catch (error) {
      setIsSuccess(false);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          'Une erreur est survenue.'
      );
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, isSuccess, archivePackaging };
}
